/* eslint-disable react/prop-types,object-curly-newline,react/react-in-jsx-scope,react/jsx-no-bind */
/* eslint-disable no-undef,no-return-assign */
import React from 'react';
import { Document, Page } from 'react-pdf';
import { get } from '../../helpers/api/get';
import './S3Item.css';

class S3Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = { image: null, show: false, numPages: 0 };
  }

  componentWillMount() {
    get(this.props.link).then(image => this.setState({ image: image.link }));
  }

  onDocumentLoadSuccess({ numPages }) {
    this.setState({
      numPages,
    });
  }

  toggleShow(e) {
    e.preventDefault();
    this.setState({ show: !this.state.show });
  }

  render() {
    const display = this.state.show ? '' : 'none';
    const click = this.toggleShow.bind(this);
    const onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);

    return (
      <span>
        <button onClick={click} >Show/Hide Image</button>
        {this.state.image && !this.props.isPdf &&
        <img src={this.state.image} style={{ width: '100%', height: 'auto', display }} alt="tailgate" />
        }
        {this.state.image && this.props.isPdf &&
        <div style={{ display }} >
          <Document
            file={this.state.image}
            onLoadSuccess={onDocumentLoadSuccess}
            style={{ width: '100%', height: 'auto', display }}
          >
            {
              Array.from(
                new Array(this.state.numPages),
                (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                  />
                ),
              )
            }
          </Document>
        </div>
        }
      </span>);
  }
}

export default S3Item;



// WEBPACK FOOTER //
// ./src/components/S3Item/S3Item.jsx